<div class="input-container" [ngClass]="{ mobile: rwdService.isSmallDevice, padding: this.padding }">
  <label>{{ labelKey | locLabel }}</label>
  <mat-radio-group
    [ngClass]="{ 'one-line': oneLine }"
    [ngModel]="value"
    (blur)="onTouch()"
    [disabled]="disabled"
    (ngModelChange)="value = $event; onChange($event)"
  >
    <mat-radio-button color="primary" *ngFor="let option of options" [value]="option.value">
      {{ option.title }}
    </mat-radio-button>
  </mat-radio-group>
  <div class="errors-container">
    <app-input-errors [control]="ngControl?.control"></app-input-errors>
  </div>
</div>
